import { FormRadioInput } from '@/core/components/FormRadioInput';
import {
  OptInOptions,
} from '@/core/interfaces/common';

import { FormRadioInputWrapper } from '@/themes/globalStyles';

interface OptCheckboxesProps {
  backgroundColor: string;
  isOptInEmail: boolean;
  isOptInText: boolean;
  handleOptChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  optIn: OptInOptions;
}

export const OptCheckboxes = ({
  backgroundColor,
  isOptInEmail,
  isOptInText,
  handleOptChange,
  optIn,
}: OptCheckboxesProps) => {
  if (optIn.defaultOptIn === true) {
    return (
      <div className="muster-optin">
        <p>
          By submitting this form, you agree to receive future communications from us.
          You can unsubscribe at any time by following the opt-out instructions provided
          in subsequent communications.
        </p>
        <p>
          If you have already unsubscribed, submitting this form will not resubscribe you.
        </p>
      </div>
    );
  }

  if (optIn.defaultOptIn === false) {
    return (
      <div className="muster-optin">
        <p>
          By submitting this form, you will not be opted in
          to receive further communications from us.
        </p>
      </div>
    );
  }

  return (
    <div className="muster-optin">
      <FormRadioInputWrapper>
        <FormRadioInput
          checked={isOptInEmail}
          color={backgroundColor}
          label={optIn.emailCheckboxText || 'Opt in to email updates'}
          name="isOptInEmail"
          onChange={handleOptChange}
        />
      </FormRadioInputWrapper>
      <FormRadioInputWrapper>
        <FormRadioInput
          checked={isOptInText}
          color={backgroundColor}
          label={optIn.textCheckboxText || 'Opt in to text updates'}
          name="isOptInText"
          onChange={handleOptChange}
        />
      </FormRadioInputWrapper>
    </div>
  );
};
